"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rootReducer = exports.reducers = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _issuesCollection = require("./ducks/issuesCollection");
var _issueTypes = require("./ducks/issueTypes");
var _issueRootCauses = require("./ducks/issueRootCauses");
var _currentUserPermissions = require("./ducks/currentUserPermissions");
var _issueCustomFields = require("./ducks/issueCustomFields");
var _issueCustomFieldMappings = require("./ducks/issueCustomFieldMappings");
var _issuePermissions = require("./ducks/issuePermissions");
var _issueComments = require("./ducks/issueComments");
var _issuesViewers = require("./ducks/issuesViewers");
var _sheets = require("./ducks/sheets");
var _issueActivityLog = require("./ducks/issueActivityLog");
var _issueTableSelection = require("./ducks/issueTableSelection");
var _documents = require("./ducks/documents");
var _issueTemplates = require("./ducks/issueTemplates");
var _issueStatuses = require("./ducks/issueStatuses");
var _relationships = require("./ducks/relationships");
var _issueSnapshots = require("./ducks/issueSnapshots");
var _issueAttachments = require("./ducks/issueAttachments");
var _reportSettings = require("./ducks/reportSettings");
var _bcfImportCollection = require("./ducks/bcfImportCollection");
const reducers = exports.reducers = {
  [_issuesCollection.STATE_KEY]: _issuesCollection.reducer,
  [_issueTypes.STATE_KEY]: _issueTypes.reducer,
  [_issueRootCauses.STATE_KEY]: _issueRootCauses.reducer,
  [_currentUserPermissions.STATE_KEY]: _currentUserPermissions.reducer,
  [_issueCustomFields.STATE_KEY]: _issueCustomFields.reducer,
  [_issueCustomFieldMappings.STATE_KEY]: _issueCustomFieldMappings.reducer,
  [_issuePermissions.STATE_KEY]: _issuePermissions.reducer,
  [_issuesViewers.STATE_KEY]: _issuesViewers.reducer,
  [_issueComments.STATE_KEY]: _issueComments.reducer,
  [_issueTemplates.STATE_KEY]: _issueTemplates.reducer,
  [_sheets.STATE_KEY]: _sheets.reducer,
  [_issueActivityLog.STATE_KEY]: _issueActivityLog.reducer,
  [_issueTableSelection.STATE_KEY]: _issueTableSelection.reducer,
  [_documents.STATE_KEY]: _documents.reducer,
  [_issueStatuses.STATE_KEY]: _issueStatuses.reducer,
  [_relationships.STATE_KEY]: _relationships.reducer,
  [_issueSnapshots.STATE_KEY]: _issueSnapshots.reducer,
  [_issueAttachments.STATE_KEY]: _issueAttachments.reducer,
  [_reportSettings.STATE_KEY]: _reportSettings.reducer,
  [_bcfImportCollection.STATE_KEY]: _bcfImportCollection.reducer
};
const rootReducer = exports.rootReducer = (0, _toolkit.combineReducers)(reducers);
//# sourceMappingURL=rootReducer.js.map